import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/ModalAditivos.css"; // Importa o CSS criado acima

function ModalSolicitacoesAditivos({ projetoId, onClose }) {
  const [aditivos, setAditivos] = useState([]);
  const [loading, setLoading] = useState(true);

  // Busca os dados ao abrir
  useEffect(() => {
    const token = localStorage.getItem("Token");

    axios
      .get(`/api/aditivos/projeto/${projetoId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setAditivos(res.data || []);
      })
      .catch((err) => {
        console.error("Erro ao buscar histórico:", err);
        setAditivos([]);
      })
      .finally(() => setLoading(false));
  }, [projetoId]);

  // Define cores e labels baseado no status
  const getStatusConfig = (status) => {
    const s = status ? status.toLowerCase() : "";

    if (s.includes("aprovado")) {
      return {
        color: "success",
        bsColor: "#198754",
        label: "Aprovado",
        bg: "#d1e7dd",
      };
    }
    if (s.includes("rejeitado") || s.includes("recusado")) {
      return {
        color: "danger",
        bsColor: "#dc3545",
        label: "Rejeitado",
        bg: "#f8d7da",
      };
    }
    if (s.includes("pendente")) {
      return {
        color: "warning",
        bsColor: "#ffc107",
        label: "Pendente",
        bg: "#fff3cd",
      };
    }
    return {
      color: "secondary",
      bsColor: "#6c757d",
      label: "Desconhecido",
      bg: "#e2e3e5",
    };
  };

  // Formata valor monetário
  const formatCurrency = (val) => {
    return val
      ? parseFloat(val).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        })
      : "-";
  };

  return (
    <div
      className="modal fade show d-block modal-backdrop-blur"
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content modal-content-clean">
          {/* Cabeçalho */}
          <div className="modal-header border-bottom-0 pb-0 pt-4 px-4 bg-white">
            <div>
              <h4 className="modal-title fw-bold text-dark mb-1">
                Histórico de Aditivos
              </h4>
              <p className="text-muted small mb-0">
                Lista completa de solicitações de prazo e valor deste projeto.
              </p>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Fechar"
            ></button>
          </div>

          {/* Corpo com Scroll Personalizado */}
          <div className="modal-body px-4 py-4 custom-scroll bg-white">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <div
                  className="spinner-border text-primary me-2"
                  role="status"
                ></div>
                <span className="text-muted">Carregando histórico...</span>
              </div>
            ) : aditivos.length === 0 ? (
              <div className="text-center py-5">
                <div className="empty-state-icon">📂</div>
                <h6 className="text-muted fw-bold">
                  Nenhuma solicitação encontrada.
                </h6>
                <p className="text-muted small">
                  Este projeto ainda não possui pedidos de aditivo.
                </p>
              </div>
            ) : (
              <div className="d-flex flex-column gap-3">
                {aditivos.map((ad) => {
                  const config = getStatusConfig(ad.status);
                  const isValor = ad.tipo === "valor";

                  return (
                    <div
                      key={ad.id}
                      className="card aditivo-card rounded-3"
                      style={{ borderLeftColor: config.bsColor }} // Define a cor da borda esquerda dinamicamente
                    >
                      <div className="card-body p-3">
                        {/* Linha 1: Badges e Data */}
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="d-flex align-items-center gap-2">
                            <span className="badge bg-light text-dark border">
                              {isValor ? "💰 Financeiro" : "📅 Cronograma"}
                            </span>
                            <span className="text-muted small">
                              {ad.data_criacao
                                ? new Date(ad.data_criacao).toLocaleDateString(
                                    "pt-BR",
                                  )
                                : "-"}
                            </span>
                          </div>

                          {/* Badge de Status Colorido */}
                          <span
                            className="badge rounded-pill px-3 py-2"
                            style={{
                              backgroundColor: config.bg,
                              color: `var(--bs-${config.color})`, // Usa a variável do Bootstrap para texto escuro
                              border: `1px solid rgba(0,0,0,0.05)`,
                            }}
                          >
                            {config.label}
                          </span>
                        </div>

                        {/* Linha 2: Valor Principal */}
                        <div className="mb-3 ps-1">
                          <div className="text-value">
                            {isValor
                              ? formatCurrency(ad.valor)
                              : `${ad.prazo} dias adicionais`}
                          </div>
                          {ad.etapa && !isValor && (
                            <small className="text-muted">
                              Referente à <strong>Etapa {ad.etapa}</strong>
                            </small>
                          )}
                        </div>

                        {/* Linha 3: Caixa de Detalhes */}
                        <div className="details-box">
                          {/* Justificativa do Pedido */}
                          <div>
                            <span className="label-small">
                              Justificativa do Pedido
                            </span>
                            <p className="mb-0 text-dark small">
                              {ad.descricao_pedido ||
                                "Nenhuma descrição fornecida."}
                            </p>
                          </div>

                          {/* Decisão (Se houver resposta) */}
                          {(ad.descricao_decisao ||
                            ad.justificativa_recusa) && (
                            <div className="decision-area">
                              <span
                                className={`label-small text-${config.color}`}
                              >
                                Parecer da Gestão
                              </span>
                              <p className="mb-0 text-dark small">
                                {ad.descricao_decisao ||
                                  ad.justificativa_recusa}
                              </p>
                              {ad.data_confirmacao && (
                                <small
                                  className="text-muted d-block mt-1 fst-italic"
                                  style={{ fontSize: "0.65rem" }}
                                >
                                  Atualizado em:{" "}
                                  {new Date(
                                    ad.data_confirmacao,
                                  ).toLocaleDateString("pt-BR")}
                                </small>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalSolicitacoesAditivos;
